export default {
  users: (state) => {
    return state.users;
  },
  meta: (state) => {
    return state.meta;
  },
  links: (state) => {
    return state.links;
  },
  loading: (state) => {
    return state.loading;
  },
  error: (state) => {
    return state.error;
  },
  tasksComingUp: (state) => {
    return state.tasks_coming_up;
  },
  profile: (state) => {
    return state.profile;
  },
};
